export default "__VITE_ASSET__CmV6mybH__"